module.exports = __webpack_public_path__ + "img/ex08.ab6c4e88.png";